import { useTranslation, Trans } from "react-i18next";

import s1 from '../../img/Home/s1.svg'
import s2 from '../../img/Home/s2.svg'
import s3 from '../../img/Home/s3.svg'

function GridAfterMain() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <div className="flex flex-col md:flex-row gap-[10px] xl:gap-[20px]">
                <div className="bg-[#F0FAF9] rounded-[4px] h-[200px] xl:h-[285px] flex-grow flex flex-col items-center justify-center">
                    <div className="bg-[#65CDBF] rounded-[10px] xl:w-[80px] xl:h-[80px] w-[60px] h-[60px] flex items-center justify-center">
                        <img src={s1} alt="" className="w-[30px] h-[30px] xl:w-[40px] xl:h-[40px]"/>
                    </div>
                    <p className="mt-[20px] xl:mt-[30px] text-[#1A0402] poppins text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('home.5')}</p>
                    <p className="mt-[10px] xl:mt-[12px] max-w-[218px] text-[#000000B2] inter text-[14px] text-center">{t('home.6')}</p>
                </div>
                <div className="bg-[#EFF2FE] rounded-[4px] h-[200px] xl:h-[285px] flex-grow flex flex-col items-center justify-center">

                <div className="bg-[#637BF5] rounded-[10px] xl:w-[80px] xl:h-[80px] w-[60px] h-[60px] flex items-center justify-center">
                        <img src={s2} alt="" className="w-[30px] h-[30px] xl:w-[40px] xl:h-[40px]"/>
                    </div>
                    <p className="mt-[20px] xl:mt-[30px] text-[#1A0402] poppins text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('home.7')}</p>
                    <p className="mt-[10px] xl:mt-[12px] max-w-[218px] text-[#000000B2] inter text-[14px] text-center">{t('home.8')}</p>
                </div>
                <div className="bg-[#F1F7FE] rounded-[4px] h-[200px] xl:h-[285px] flex-grow flex flex-col items-center justify-center">

                <div className="bg-[#061A77] rounded-[10px] xl:w-[80px] xl:h-[80px] w-[60px] h-[60px] flex items-center justify-center">
                        <img src={s3} alt="" className="w-[30px] h-[30px] xl:w-[40px] xl:h-[40px]"/>
                    </div>
                    <p className="mt-[20px] xl:mt-[30px] text-[#1A0402] poppins text-[16px] xl:text-[20px] leading-[1.2] font-[500] max-w-[206px] text-center">{t('home.9')}</p>
                    <p className="mt-[10px] xl:mt-[12px] max-w-[218px] text-[#000000B2] inter text-[14px] text-center">{t('home.10')}</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default GridAfterMain;
